import React, {Children} from 'react';
import useCollapse from 'react-collapsed';


function Collapsible(props) {
    const config = {
        defaultExpanded: props.defaultExpanded || false
    };
    const {getCollapseProps, getToggleProps, isExpanded} = useCollapse(config);
    
    return (
        <div className="collapsible">
            <div className="header" {...getToggleProps()}>
                <h2><span>{isExpanded ? "▲": "▼"}</span> {props.title} </h2>
            </div>
            <div {...getCollapseProps()}>
                <div className="content">{props.children}</div>
            </div>
        </div>
    )
}

export default Collapsible